import React from 'react';
import VehicleModelRow from './VehicleModelRow';
import FilterableTable from '../filters/FilterableTable';

const VehicleModelTable = ({
  dispatch,
  vehicleModelReducer,
  findAllVehicleModelPageble,
  updateVehicleModel,
  deleteVehicleModel,
  clearValidationErrors,
  brandReducer
}) => {
  const { vehicleModelList, totalElements } = vehicleModelReducer;

  let vehicleModelNameList = vehicleModelList.map((vehicleModel, index) => (
    <VehicleModelRow
      key={vehicleModel.id}
      vehicleModel={vehicleModel}
      deleteVehicleModel={deleteVehicleModel}
      updateVehicleModel={updateVehicleModel}
      dispatch={dispatch}
      clearValidationErrors={clearValidationErrors}
      vehicleModelReducer={vehicleModelReducer}
      brandReducer={brandReducer}
    />
  ));

  const columns = [
   {
      id: 'Brend',
      name: 'Brend',
      filter: {
        field: 'brand.brandName',
        value: '',
        type: 'CHILD_LIKE',
      },
    },
    {
      id: 'Model ',
      name: 'Model ',
      filter: {
        field: 'modelName',
        value: '',
        type: 'LIKE',
      },
    },
    { id: 'Измена', name: 'Измена' },
    { id: 'Брисање', name: 'Брисање' },
  ];

  return (
    <>
      <FilterableTable
        tableStyle="table-container-with-row-below"
        columns={columns}
        action={findAllVehicleModelPageble}
        rows={vehicleModelNameList}
        totalElements={totalElements}
        filterPosition
      ></FilterableTable>
    </>
  );
};

export default VehicleModelTable;
